module.exports = __webpack_public_path__ + "img/四川发展.5435ccc2.png";